module.exports = __webpack_public_path__ + "img/icon-button-add.dc5ac910.svg";